import React, { useEffect, useState } from "react";
import classes from "./template-data.module.scss";
import Editor from "@monaco-editor/react";
import { debounce } from "throttle-debounce";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { selectJsonTemplateData } from "../../../../reducers/project/selectors";
import { useDispatch, useSelector } from "react-redux";
import { setJsonTemplateData } from "../../../../reducers/project/actions";
import classNames from "classnames";

const TemplateData = ({}) => {
  const dispatch = useDispatch();
  const jsonTemplateData = useSelector(selectJsonTemplateData);

  const [errors, setErrors] = useState([]);
  const [jsonData, setJsonData] = useState(
    JSON.stringify(jsonTemplateData, null, 4)
  );

  const onChangeValue = debounce(500, (value) => {
    try {
      setJsonData(JSON.stringify(JSON.parse(value), null, 4));
    } catch (e) {
      console.log("ERROR JSON PARSE MACROS");
    }
  });

  const onValidate = (markers) => {
    setErrors(markers);
    setTimeout(() => {
      if (markers.length === 0) {
        dispatch(setJsonTemplateData(jsonData));
      }
    }, 2000);
  };

  useEffect(() => {
    setJsonData(jsonTemplateData);
  }, [jsonTemplateData]);

  return (
    <div className={classNames(classes.JsonContentWrap, {[classes.Error]: !!errors.length})}>
      <Editor
        className={classes.InputDataEditor}
        language="json"
        wordWrap="on"
        tabSize={2}
        options={{
          minimap: { enabled: false },
          fontSize: 14,
        }}
        value={jsonTemplateData}
        theme="light"
        onChange={onChangeValue}
        onValidate={onValidate}
      />

      {!!errors.length && (
        <div className={classes.ErrorContent}>
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className={"me-1 text-danger"}
          />
          <span>Line {errors[0].startLineNumber}: </span>
          {errors[0].message}
        </div>
      )}
    </div>
  );
};

export default TemplateData;
